/*
============================================================
     Popup upsell abbonamento — SOLO PDP MAG5+ (template product.mag5).
     Autonomo: non tocca il bundle (v42) né il CSS (v47) già live.
     Innesti sul resto della pagina: due soli, entrambi reversibili.
       1) listener click in CAPTURE che REGISTRA l'intenzione (non la blocca):
          il prodotto finisce comunque nel carrello come sempre;
       2) getter su window.aovCartDrawerUpdateAndOpen / aovCartDrawerOpen:
          quando l'aggiunta è "una tantum" mostriamo il popup INVECE del
          drawer, e apriamo il drawer vero appena l'utente ha scelto.
     Qualunque errore → si apre il drawer come prima. Il carrello è già
     corretto in ogni caso: qui si può solo migliorare la riga, mai perderla.
     ============================================================
*/
(function () {
  var CFG = window.__MAG5_CONFIG__ || {};
  var U = CFG.upsell;
  var P = CFG.purchase || {};
  var SUB = P.subscription || {};
  var PLAN = U && (U.sellingPlanId || SUB.sellingPlanId);
  if (!U || !PLAN) return;                       // nessuna config → nessun popup

  var KEY = 'mag5:subupsell';
  var pending = null;   // { id, qty, plan, t } — l'ultimo clic su una CTA carrello
  var busy = false;
  var apertura = false;        // lucchetto SINCRONO: fra il clic e il disegno passano
  var prevOverflow = null;     // ~800ms, in cui una seconda chiamata passerebbe le guardie
  var root = null;
  var drawer = null;    // funzione vera del drawer, da richiamare a scelta fatta

  var fmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });
  // arrotonda ai centesimi come fa lo store (half-up). L'epsilon serve perché
  // in virgola mobile 29.925*100 = 2992.4999... e verrebbe giù a 29,92
  // invece che a 29,93: tre confezioni sbaglierebbero di 3 centesimi.
  function r2(n) { return Math.round(n * 100 + (n < 0 ? -1e-6 : 1e-6)) / 100; }
  // ?upsell=1 nell'URL forza il popup anche se in questa sessione e gia uscito:
  // serve per provarlo senza dover svuotare la sessione del browser.
  var FORCE = /[?&]upsell=1/.test(location.search);
  function seen() {
    if (FORCE) return false;
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function mark() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }

  /* ---------- 1 · registra l'intenzione, senza intralciare il clic ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('a[href*="/cart/"]') : null;
    if (!a) return;
    var m = (a.getAttribute('href') || '').match(/\/cart\/(\d+):(\d+)(?:\?selling_plan=(\d+))?/);
    pending = m ? { id: m[1], qty: Number(m[2]), plan: m[3] || '', t: Date.now() } : null;
  }, true);

  /* ---------- 2 · il drawer passa da qui ---------- */
  function armed() {
    return !!pending && !pending.plan && (Date.now() - pending.t) < 10000 && !seen() && !root;
  }
  ['aovCartDrawerUpdateAndOpen', 'aovCartDrawerOpen'].forEach(function (name) {
    var real = window[name];
    try {
      Object.defineProperty(window, name, {
        configurable: true,
        get: function () {
          if (!armed()) return real;
          return function () {
            var fn = real;
            try { maybeOpen(fn); }
            catch (err) { if (typeof fn === 'function') fn(); }
          };
        },
        set: function (v) { real = v; }
      });
    } catch (e) { /* browser che non consente la property: il drawer resta quello di prima */ }
  });

  /* L'app AOV (Avada) apre il suo drawer DA SOLA appena il carrello cambia:
     non basta intercettare la funzione, va richiuso. Lo richiudiamo per un
     secondo, finché il popup è a schermo — poi lo riapriamo noi, a scelta fatta. */
  function hideAov() {
    [0, 120, 300, 600, 1000].forEach(function (ms) {
      setTimeout(function () {
        if (!root && ms) return;                 // popup già chiuso → non toccare più nulla
        try { if (typeof window.aovCartDrawerClose === 'function') window.aovCartDrawerClose(); } catch (e) {}
      }, ms);
    });
  }

  function openDrawer() {
    var fn = drawer;
    if (typeof fn === 'function') { fn(); return; }
    // l'app AOV può arrivare tardi: riprova per ~2,4s, poi ripiega sul drawer del tema
    var n = 12;
    (function retry() {
      if (typeof window.aovCartDrawerUpdateAndOpen === 'function') return window.aovCartDrawerUpdateAndOpen();
      if (typeof window.aovCartDrawerOpen === 'function') return window.aovCartDrawerOpen();
      if (--n <= 0) {
        var cd = document.querySelector('cart-drawer');
        if (cd && cd.open) cd.open();
        return;
      }
      setTimeout(retry, 200);
    })();
  }

  /* ---------- 3 · si apre solo se ha davvero senso ---------- */
  function maybeOpen(realDrawer) {
    if (apertura || root) { if (typeof realDrawer === 'function') realDrawer(); return; }
    apertura = true;
    drawer = realDrawer;
    hideAov();                                   // subito, non dopo la fetch: toglie
                                                 // il lampo del drawer che si apre e chiude
    // il flag "gia visto" si scrive SOLO quando il popup compare davvero
    // (vedi render): se qui usciamo per una delle guardie, il cliente deve
    // poterlo vedere al tentativo dopo.
    var scaduto = new Promise(function (ok) { setTimeout(function () { ok(null); }, 1800); });
    Promise.race([
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
      scaduto
    ])
      .then(function (cart) {
        if (!cart) return openDrawer();          // rete lenta: meglio il drawer che il vuoto
        var line = null, hasSub = false;
        (cart.items || []).forEach(function (it) {
          if (it.selling_plan_allocation) hasSub = true;
          if (String(it.variant_id) === String(pending.id) && !it.selling_plan_allocation) line = it;
        });
        // niente popup se: c'è già un abbonamento nel carrello, la riga non si
        // trova, oppure si è fusa con una quantità preesistente (in quel caso
        // convertirla toccherebbe anche pezzi che l'utente non ha appena scelto)
        if (hasSub || !line || line.quantity !== pending.qty) return openDrawer();
        render(line);
      })
      .catch(function () { openDrawer(); })
      .then(function () { apertura = false; });
  }

  /* ---------- 4 · il popup ---------- */
  function render(line) {
    var qty = pending.qty;
    var tier = 0, totalFixed = null;
    (P.options || []).forEach(function (o) {
      if (Number(o.qty) !== qty) return;
      tier = Number(o.discountPct) || 0;
      if (o.totalPrice != null) totalFixed = Number(o.totalPrice);
    });
    // ATTENZIONE all'ordine degli arrotondamenti: lo store sconta e arrotonda
    // AL PEZZO, poi moltiplica (2 conf. = 33,92 × 2 = 67,84 €, non 67,83).
    // Calcolare sul totale sballa di 1–2 centesimi rispetto al carrello vero.
    var base = Number(P.basePrice) || 0;
    // alcune PDP fissano il totale del pack nel config (totalPrice) invece di
    // affidarsi alla percentuale: in quel caso comanda quello, e il prezzo al
    // pezzo si ricava da li.
    var one = totalFixed != null ? totalFixed : r2(r2(base * (1 - tier / 100)) * qty);
    var unitOnePrice = r2(one / qty);
    var unitSubPrice = r2(unitOnePrice * (1 - (Number(SUB.discountPct) || 0) / 100));
    var sub = r2(unitSubPrice * qty);
    var save = r2(one - sub);
    // regali della PRIMA consegna: una lista (possono essere piu d'uno)
    var g1 = U.gifts || (U.firstGift ? [U.firstGift] : []);
    var gN = U.everyGift || null;                 // regalo ricorrente (puo non esserci)
    var gift = 0;
    g1.forEach(function (x) { gift = r2(gift + (Number(x.value) || 0)); });
    var tot = r2(save + gift);
    var unit = U.unitOne || P.unitLabel || 'pezzo';
    var units = U.unitMany || unit.replace(/o$/, 'i');
    var jar = qty + ' ' + (qty === 1 ? unit : units);
    var freq = U.frequency || SUB.frequency || 'ogni mese';
    var rating = CFG.ratingSummary || {};

    root = document.createElement('div');
    root.id = 'msu-root';
    if ((g1.length + (gN ? 1 : 0)) >= 3) root.className = 'msu-dense';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'msu-titolo');
    root.innerHTML = [
      '<div class="msu-modal">',
        '<button class="msu-x" aria-label="Chiudi"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>',
        '<div class="msu-added"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg><span>' + esc(CFG.name || 'Prodotto') + ' · ' + esc(jar) + ' ' + esc(qty === 1 ? (U.addedOne || 'aggiunto al carrello') : (U.addedMany || 'aggiunti al carrello')) + '</span></div>',
        '<div class="msu-body">',
          '<span class="msu-kicker"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 15.5-6.2M21 12a9 9 0 0 1-15.5 6.2"/><path d="M18 3v4h-4M6 21v-4h4"/></svg>' + esc(U.kicker || 'Solo con la consegna automatica') + '</span>',
          '<h2 class="msu-h" id="msu-titolo">' + titolo(gift, save, qty, unit, units) + '</h2>',
          '<p class="msu-sub"><span class="msu-sub-l">Attiva la consegna automatica <b>' + esc(freq) + '</b>: paghi <b>' + fmt.format(sub) + '</b> invece di <b>' + fmt.format(one) + '</b> su ogni consegna.' + (U.subTail ? ' ' + U.subTail : '') + '</span>' +
            '<span class="msu-sub-c">Paghi <b>' + fmt.format(sub) + '</b> invece di <b>' + fmt.format(one) + '</b>, ' + esc(freq) + '.</span></p>',
          prodCard(one, sub, jar),
          giftPanel(g1, gN, gift),
          '<div class="msu-opts" role="radiogroup" aria-label="Come vuoi riceverlo">',
            '<button type="button" role="radio" aria-checked="true" class="msu-opt msu-on" data-k="sub"><span class="msu-dot"></span><span class="msu-om">',
              '<span class="msu-ot">Consegna ' + esc(freq) + '<span class="msu-tag">−' + (Number(SUB.discountPct) || 0) + '% sempre</span></span>',
              '<span class="msu-on-note">Salti, rimandi o annulli in un clic · Spedizione sempre gratuita</span>',
            '</span><span class="msu-op"><span class="msu-was">' + fmt.format(one) + '</span><span class="msu-now">' + fmt.format(sub) + '</span><span class="msu-unit">a consegna</span></span></button>',
            '<button type="button" role="radio" aria-checked="false" class="msu-opt" data-k="one"><span class="msu-dot"></span><span class="msu-om">',
              '<span class="msu-ot">Una volta sola</span><span class="msu-on-note">Nessun regalo, prezzo pieno</span>',
            '</span><span class="msu-op"><span class="msu-now">' + fmt.format(one) + '</span><span class="msu-unit">una tantum</span></span></button>',
          '</div>',
        '</div>',
        '<div class="msu-foot">',
          totBar(save, tot, gift, gN),
          '<button class="msu-cta"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 15.5-6.2M21 12a9 9 0 0 1-15.5 6.2"/><path d="M18 3v4h-4M6 21v-4h4"/></svg><span class="msu-ctat">Attiva e risparmia ' + fmt.format(tot) + '</span></button>',
          '<button class="msu-decl"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6h15l-1.5 9h-12z"/><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M6 6 5 2H2"/></svg><span>No grazie, acquisto una volta sola</span><span class="msu-dp">' + fmt.format(one) + '</span></button>',
          '<p class="msu-nov"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="4" y="10" width="16" height="10" rx="2.5"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>Nessun vincolo: l\'abbonamento si annulla anche prima della prima consegna</p>',
          '<div class="msu-trust">' + trust(rating) + '</div>',
        '</div>',
      '</div>'
    ].join('');

    document.body.appendChild(root);
    if (prevOverflow === null) prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    var cta = root.querySelector('.msu-cta');
    var decl = root.querySelector('.msu-decl');
    var ctat = root.querySelector('.msu-ctat');
    var chosen = 'sub';

    root.querySelectorAll('.msu-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        chosen = b.getAttribute('data-k');
        root.querySelectorAll('.msu-opt').forEach(function (x) {
          x.classList.toggle('msu-on', x === b);
          x.setAttribute('aria-checked', x === b ? 'true' : 'false');
        });
        ctat.textContent = chosen === 'sub' ? 'Attiva e risparmia ' + fmt.format(tot) : 'Continua senza abbonamento';
        var pannelli = root.querySelectorAll('.msu-tot, .msu-gift');
        for (var i = 0; i < pannelli.length; i++) pannelli[i].style.opacity = chosen === 'sub' ? 1 : .35;
      });
    });

    var focusPrec = document.activeElement;
    // l'app del drawer ruba il focus mentre la richiudiamo (timer fino a 1s):
    // lo riprendiamo finche il popup e aperto, altrimenti chi usa la tastiera
    // si ritrova a tabulare dentro il carrello nascosto sotto
    function prendiFocus() {
      if (root && !root.contains(document.activeElement)) { try { cta.focus(); } catch (e) {} }
    }
    prendiFocus();
    [200, 700, 1200].forEach(function (ms) { setTimeout(prendiFocus, ms); });

    function close() {
      if (!root) return;
      mark();                                    // una volta per sessione: da QUI
      document.body.style.overflow = prevOverflow;
      root.remove();
      root = null;
      document.removeEventListener('keydown', onKey);
      try { focusPrec && focusPrec.focus && focusPrec.focus(); } catch (e) {}
      openDrawer();
    }
    function onKey(e) {
      if (e.key === 'Escape') return close();
      if (e.key !== 'Tab' || !root) return;
      // il focus non deve uscire dal modale finche e aperto
      var f = root.querySelectorAll('button:not([disabled]):not([tabindex="-1"])');
      if (!f.length) return;
      var primo = f[0], ultimo = f[f.length - 1];
      if (e.shiftKey && document.activeElement === primo) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primo.focus(); }
    }
    document.addEventListener('keydown', onKey);

    // sugli schermi bassi il CSS rende le card inerti: se non sono cliccabili
    // non devono nemmeno essere tabulabili, altrimenti si cambia scelta al buio
    function sincronizzaOpzioni() {
      root.querySelectorAll('.msu-opt').forEach(function (x) {
        var cs = getComputedStyle(x);
        var spenta = cs.display === 'none' || cs.pointerEvents === 'none';
        x.tabIndex = spenta ? -1 : 0;
        if (spenta) x.setAttribute('aria-hidden', 'true'); else x.removeAttribute('aria-hidden');
      });
    }
    sincronizzaOpzioni();
    // sfumatura in fondo solo quando c'e davvero altro sotto: senza, il taglio
    // sembrava un errore di impaginazione invece di un contenuto da scorrere
    var corpo = root.querySelector('.msu-body');
    function segnalaScroll() {
      corpo.classList.toggle('msu-scroll', corpo.scrollHeight - corpo.clientHeight > 6);
    }
    segnalaScroll();
    corpo.addEventListener('scroll', function () {
      corpo.classList.toggle('msu-scroll', corpo.scrollHeight - corpo.scrollTop - corpo.clientHeight > 6);
    });
    window.addEventListener('resize', function () { sincronizzaOpzioni(); segnalaScroll(); });
    window.addEventListener('resize', sincronizzaOpzioni);

    root.querySelector('.msu-x').addEventListener('click', close);
    decl.addEventListener('click', close);
    root.addEventListener('mousedown', function (e) { if (e.target === root) close(); });

    cta.addEventListener('click', function () {
      if (chosen !== 'sub') return close();
      if (busy) return;
      busy = true;
      cta.setAttribute('disabled', '');
      decl.setAttribute('disabled', '');
      ctat.textContent = 'Attivo l\'abbonamento…';
      cta.querySelector('svg').outerHTML = '<span class="msu-spin"></span>';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ id: line.key, quantity: line.quantity, selling_plan: Number(PLAN) })
      })
        .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
        .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
        .catch(function () { /* la riga una tantum resta nel carrello: nulla di perso */ })
        .then(function () { busy = false; close(); });
    });
  }

  // Il prodotto stesso, scontato: e la prima cosa che si riceve con l'abbonamento,
  // quindi va in evidenza sopra ai regali (prima il prezzo vero, poi gli omaggi).
  function prodCard(one, sub, jar) {
    var pct = Number(SUB.discountPct) || 0;
    if (!(sub < one)) return '';
    var ps = (CFG.packshot && CFG.packshot.src) || (CFG.gallery && CFG.gallery[0] && CFG.gallery[0].src) || '';
    var img = ps ? ps + (ps.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
    var name = U.productName || CFG.name || '';
    return '<div class="msu-prod">' +
      (img ? '<img class="msu-prod-img" src="' + esc(img) + '" alt="" loading="lazy">' : '') +
      '<div class="msu-prod-m"><span class="msu-prod-k">Il tuo prodotto, scontato</span>' +
      '<div class="msu-prod-t">' + esc(name) + ' <span>· ' + esc(jar) + '</span></div>' +
      '<div class="msu-prod-s">' + (pct ? '\u2212' + pct + '% ' : '') + 'su ogni consegna</div></div>' +
      '<div class="msu-prod-p"><div class="msu-old">' + fmt.format(one) + '</div>' +
      '<div class="msu-prod-now">' + fmt.format(sub) + '</div>' +
      (pct ? '<span class="msu-prod-tag">\u2212' + pct + '%</span>' : '') + '</div></div>';
  }

  // Pannello regali: si disegna solo se il config ne dichiara almeno uno.
  // Nessun regalo dichiarato = nessun pannello. Non promettiamo cio che il
  // carrello non consegna: su Regolarita, per esempio, le Multivitamine NON scattano.
  function giftPanel(gifts, gN, giftValue) {
    if ((!gifts || !gifts.length) && !gN) return '';
    var rows = '';
    (gifts || []).forEach(function (g) {
      rows += '<div class="msu-row">' +
        (g.image ? '<img class="msu-img' + (g.fit === 'contain' ? ' msu-fit' : '') + '" src="' + esc(g.image) + '" alt="" loading="lazy">' : '') +
        '<div><span class="msu-when">' + esc(g.when || '1\u00AA consegna') + '</span>' +
        '<div class="msu-t">' + esc(g.title || '') + '</div>' +
        (g.note ? '<div class="msu-s">' + esc(g.note) + '</div>' : '') + '</div>' +
        '<div class="msu-p">' + (g.value ? '<div class="msu-old">' + fmt.format(g.value) + '</div>' : '') +
        '<div class="msu-new">Gratis</div></div></div>';
    });
    if (gN) rows += '<div class="msu-row">' +
      (gN.image ? '<img class="msu-img" src="' + esc(gN.image) + '" alt="" loading="lazy">' : '') +
      '<div><span class="msu-when msu-ever">' + esc(gN.when || 'Ogni consegna') + '</span>' +
      '<div class="msu-t">' + esc(gN.title || '') + '</div>' +
      (gN.note ? '<div class="msu-s">' + esc(gN.note) + '</div>' : '') + '</div>' +
      '<div class="msu-p"><div class="msu-new msu-ever">Sempre</div></div></div>';
    // la testata porta il valore: e il numero che rende l'offerta leggibile a colpo d'occhio
    var head = giftValue
      ? 'In regalo \u00b7 valore ' + fmt.format(giftValue)
      : (U.giftHead || 'Un regalo in ogni pacco, sempre');
    return '<div class="msu-gift"><div class="msu-gift-head">' +
      '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><rect x="3" y="9" width="18" height="12" rx="2"/><path d="M3 13h18M12 9v12"/><path d="M12 9S10.6 4.5 8.2 4.5a2.3 2.3 0 0 0 0 4.5zM12 9s1.4-4.5 3.8-4.5a2.3 2.3 0 0 1 0 4.5z"/></svg>' +
      esc(head) + '</div>' + rows + '</div>';
  }

  // Con un regalo di valore il numero grosso e il vantaggio della PRIMA consegna;
  // senza, e semplicemente lo sconto che si ripete.
  function totBar(save, tot, giftValue, gN) {
    var titolo = giftValue ? 'Vantaggio sulla prima consegna' : 'Risparmio su ogni consegna';
    var sotto = giftValue
      ? (U.renewalShort || 'Lo sconto di ' + fmt.format(save) + (gN ? ' e il regalo valgono su ogni consegna' : ' vale su ogni consegna') + ', non solo sulla prima')
      : (gN ? 'E un regalo in ogni pacco, sempre' : '');
    return '<div class="msu-tot"><span class="msu-tot-l">' + titolo +
      (sotto ? '<span class="msu-tot-s">' + sotto + '</span>' : '') +
      '</span><span class="msu-tot-r">' + fmt.format(tot) + '</span></div>';
  }

  // Con dei regali di valore l'apertura deve essere QUELLA cifra: aprire con lo
  // sconto (7,98 su 39,90) piazza un'ancora debole prima del numero grosso.
  function titolo(gift, save, qty, unit, units) {
    if (gift) {
      return '<em>' + fmt.format(gift) + ' di regali</em> nel primo pacco. E ' +
             fmt.format(save) + ' in meno su ogni consegna.';
    }
    var U2 = U || {};
    return esc(qty === 1 ? (U2.sameOne || 'Lo stesso ' + unit) : (U2.sameMany || 'Gli stessi ' + units)) +
           ', <em>' + fmt.format(save) + ' in meno</em>.' + (U2.headTail ? ' ' + esc(U2.headTail) : '');
  }

  function trust(r) {
    var out = [];
    if (r && r.average) out.push('<span><span class="msu-stars">★★★★★</span> <b>' + String(r.average).replace('.', ',') + '</b>/5 · ' + (r.count || 0) + ' recensioni</span>');
    if (CFG.soldSeal) out.push('<span><b>' + esc(CFG.soldSeal) + '</b> bustine vendute</span>');
    out.push('<span><b>Made in Italy</b></span>');
    return out.join('');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
})();
